/* @flow */
const prefix = str => `station/create/${str}`;

export const INITIALIZE = prefix('INITIALIZE');
export const SET_STAGE = prefix('SET_STAGE');
export const SET_SUBMISSION_TYPE = prefix('SET_SUBMISSION_TYPE');
export const TOGGLE_REDACTION = prefix('TOGGLE_REDACTION');

export const REVIEW_REPORT = prefix('REVIEW_REPORT');
export const REVIEW_REPORT_SUCCESS = prefix('REVIEW_REPORT_SUCCESS');
export const REVIEW_REPORT_FAILURE = prefix('REVIEW_REPORT_FAILURE');

export const SUBMIT_REPORT = prefix('SUBMIT_REPORT');
export const SUBMIT_REPORT_SUCCESS = prefix('SUBMIT_REPORT_SUCCESS');
export const SUBMIT_REPORT_FAILURE = prefix('SUBMIT_REPORT_FAILURE');

export const POLL_FOR_REPORT = prefix('POLL_FOR_REPORT');
export const REPORT_POLLING_FAILURE = prefix('REPORT_POLLING_FAILURE');
export const REPORT_PROCESSED = prefix('REPORT_PROCESSED');

export const SUBMIT_INDICATORS = prefix('SUBMIT_INDICATORS');
export const SUBMIT_INDICATORS_SUCCESS = prefix('SUBMIT_INDICATORS_SUCCESS');
export const SUBMIT_INDICATORS_FAILURE = prefix('SUBMIT_INDICATORS_FAILURE');

export const SUBMIT_INDICATORS_FILE = prefix('SUBMIT_INDICATORS_FILE');

export const UPDATE_REPORT = prefix('UPDATE_REPORT');
export const UPDATE_REPORT_SUCCESS = prefix('UPDATE_REPORT_SUCCESS');
export const UPDATE_REPORT_FAILURE = prefix('UPDATE_REPORT_FAILURE');

export const ATTACH_FILE = prefix('ATTACH_FILE');
export const UPLOAD_FILE = prefix('UPLOAD_FILE');
export const ATTACH_FILE_FAILURE = prefix('ATTACH_FILE_FAILURE');
export const UPLOAD_FILE_SUCCESS = prefix('UPLOAD_FILE_SUCCESS');
export const UPLOAD_FILE_FAILURE = prefix('UPLOAD_FILE_FAILURE');

export const ATTACH_INDICATORS_SPREADSHEET_FILE = prefix('ATTACH_INDICATORS_SPREADSHEET_FILE');
export const ATTACH_INDICATORS_SPREADSHEET_FILE_FAILURE = prefix('ATTACH_INDICATORS_SPREADSHEET_FILE_FAILURE');
export const ATTACH_INDICATORS_SPREADSHEET_FILE_SUCCESS = prefix('ATTACH_INDICATORS_SPREADSHEET_FILE_SUCCESS');

export const LOAD_REPORT_DATA = prefix('LOAD_REPORT_DATA');
export const LOAD_EXISTING_REPORT_CONTENT = prefix('LOAD_EXISTING_REPORT_CONTENT');

export const REGISTER_FORM = prefix('REGISTER_FORM');
export const SET_FIELD_VALUE = prefix('SET_FIELD_VALUE');
export const SET_FORM_VALUES = prefix('SET_FORM_VALUES');
export const UNREGISTER_FORM = prefix('UNREGISTER_FORM');
export const RESET_FORM = prefix('RESET_FORM');



// WEBPACK FOOTER //
// ./src/app/modules/create/action-types.js